
import { Injectable } from "@angular/core";
import jspdf from "jspdf";
import "jspdf-autotable";
import autoTable from "jspdf-autotable";

@Injectable({
    providedIn: "root",
})
export class PdfService
{

    constructor() { }

    exportPaymentPdf(myData: any[])
    {
        const col = [["Date", "Ref Number", "Status", "Check Number", "Amount"]];

        // format numbers- price to 2 decimals
        for (const element of myData)
        {
            element[4] = element[4].toFixed(2);
        }
        this.exportPDF(myData, col);
    }

    exportTransactionPdf(myData: any[])
    {
        const col = [["Date", "Ref Number", "Description", "Status", "Location", "Type", "Qty", "Price", "Amount"]];

        // format numbers (price & qty, 2 decimals, unit price 5 decimals)
        for (const element of myData)
        {
            element[6] = element[6].toFixed(2);
            element[8] = element[8].toFixed(2);
            element[7] = element[7].toFixed(5);
        }
        this.exportPDF(myData, col);
    }

    public exportPDF(myData: any, col: any[]): void
    {
        const doc = new jspdf("landscape");

        autoTable(doc, {
            head: col,
            body: myData,
            styles: {
                halign: "right",
            },
        });
        doc.save("transactions_export.pdf");
    }
}
